const fr = {
  demo: {
    title: `France`,
  },

  Home: `Maison`,
  Dashboard: `Tableau de bord`,
  description: `description`,
  Description: `La description`,
  Details: `Détails`,
  Book: `Livre`,
  Books: `Livres`,
  Invoices: `Factures`,
  Theme: `Thème`,
  Settings: `Paramètres`,
  "Theme Settings": `Paramètres du thème`,
  Pages: `Pages`,
  Product: `Produit`,
  Contacts: `Contacts`,
  "Account Settings": `Paramètres du compte`,
  Notifications: `Les notifications`,
  More: `Plus`,
  Profile: `Profil`,
  Logout: `Se déconnecter`,
  "Add To Cart": `Ajouter au panier`,
  "Buy Now": `Acheter maintenant`,
  "Save Changes": `Sauvegarder les modifications`,
  "Create Success!": `Créer un succès!`,
  "Update Success!": `Mise à jour réussie!`,
  "Book Name": `Nom du livre`,
  "New Book": `Nouveau livre`,
  "Create Book": `Créer un livre`,
  "Create a new book": `Créer un nouveau livre`,
  "Edit Book": `Modifier le livre`,
  "Regular Price": `Prix régulier`,
  "Are you sure want to delete": `Voulez-vous vraiment supprimer`,
  "Book Details": `Détails du livre`,
  "Item for Approval": `Article pour approbation`,
  "Are you sure want to approve this item?": `Voulez-vous vraiment approuver cet article?`,
  "First Name": `Prénom`,
  "Last Name": `Nom de famille`,
  "Email Address": `Adresse e-mail`,
  "Phone Number": `Numéro de téléphone`,
  "Please Select Country Code": `Veuillez sélectionner le code du pays`,
  "State/Region": `État / Région`,
  "Zip/Code": `Zip / Code`,
  "Please Select a Role": `Veuillez sélectionner un rôle`,
  "User: List | Minimal UI": `Utilisateur: Liste | Interface utilisateur minimale`,
  "User List": `Liste d'utilisateurs`,
  "New User": `Nouvel utilisateur`,
  Email: `Email`,
  Gender: `Le genre`,
  Country: `Pays`,
  State: `Etat`,
  City: `Ville`,
  Role: `Rôle`,
  Company: `Compagnie`,
  Address: `Adresse`,
  Verified: `Vérifié`,
  "No Data": `Pas de données`,
  Images: `Images`,
  Save: `Sauvegarder`,
  Cancel: `Annuler`,
  Quantity: `Quantité`,
  Color: `Couleur`,
  Size: `Taille`,
  Name: `Nom`,
  Status: `Statut`,
  Price: `Prix`,
  "Created At": `Créé à`,
  delete_confirmation: `Voulez-vous vraiment supprimer {{value1}} élément?`,
  approve_success: `Votre livre {{value1}} est approuvé`,
  app: `application`,
  User: `Utilisateur`,
  Users: `Utilisateurs`,
  items: `articles`,
  list: `liste`,
  Add: `Ajouter`,
  Edit: `Editer`,
  Delete: `Effacer`,
  Approved: `Approuvé`,
  Approve: `Approuver`,
  Share: `Partager`,
  Notification: `Notification`,
  Sort: `Trier`,
  Search: `Chercher`,
  Filter: `Filtre`,
  analytics: `analytique`,
  ecommerce: `e-commerce`,
  Management: `Gestion`,
  Title: `Titre`,
  Date: `Rendez-vous amoureux`,
  Time: `Temps`,
  "Detail user": `Détail de l'utilisateur`,
  "Edit user": `Modifier l'utilisateur`,
  "Create a new user": `Créer un nouvel utilisateur`,
  "Create User": `Créer un utilisateur`,
  "Approve this User?": `Approuver cet utilisateur?`,
  "Enabling this will now allow user to login.": `En activant ceci, l'utilisateur pourra maintenant se connecter.`,
  "Activate this account?": `Activer ce compte?`,
  "Disabling this will deactivate users account.": `En désactivant ceci, le compte des utilisateurs sera désactivé.`,
  "First Name is required": `Le prénom est requis`,
  "Email is required": `Email est requis`,
  "Email must be a valid email address": `L'e-mail doit être une adresse e-mail valide`,
  "Phone number is required": `Le numéro de téléphone est requis`,
  "Role is required": `Le rôle est requis`,
  "Name is required": `Le nom est requis`,
  "Price should not be $0.00": `Le prix ne doit pas être de 0,00 $`,
  "Description is required": `La description est requise`,
  "You have 0 unread messages": `Vous avez 0 messages non lus`,
  "View All": `Voir tout`,
  Unread: 'Non lu',
  Read: 'Lire',
  Mode: `Mode`,
  Contrast: 'Contraste',
  Direction: 'Direction',
  Layout: `Mise en page`,
  Stretch: `Extensible`,
  Presets: 'Préconfigurations',
  "Only available at large resolutions > 1600px (xl)": `Uniquement disponible en grandes résolutions > 1600px (xl)`,
  Reset: `Réinitialiser`,
  "Send Custom Emails": `Envoyer des e-mails personnalisés`,
  "Email Subject": `Sujet du courriel`,
  "Email Body": `Corps de l'e-mail`,
  Send: 'Envoyer',
  "Current Download": 'Téléchargements actuels',
  "Area Installed": "Zone installée",
  "Balance Statistics": "Statistiques de solde",
  General: 'Général',
  "Change password": `Changer le mot de passe`,
  Allowed: 'Permis',
  'max size': 'taille max',
  About: 'À propos',
  'Old Password': 'ancien mot de passe',
  'New Password': 'nouveau mot de passe',
  'Confirm New Password': 'Confirmer le nouveau mot de passe',
  'Super Admin': 'Super administrateur',
  Admin: 'Administrateur',
  'Organization Admin': `Administrateur de l'organisation`,
  'Organization User': `Utilisateur de l'organisation`,
  'Individual User': 'Utilisateur individuel',
  Dense: 'Dense',
  selected: 'choisi',
  Asia: 'Asie', //new
  America: 'Amérique', //new
  Total: 'Total', //new
  Income: 'Revenu', //new
  Expense: 'Frais', //new
  'than last year': "que l'année dernière", //new
  'max size of': 'taille maximale de', //new
  'Update photo': 'Mettre à jour la photo', //new
  'Upload photo': 'Envoyer la photo', //new
  'Please Select Gender': 'Veuillez sélectionner le sexe',
  'Please Select a country': 'Veuillez sélectionner un pays',
  'Please Select a role': 'Veuillez sélectionner un rôle',
  Yes: '',
  No: 'Non',
  Male: 'Mâle',
  Female: 'Femelle',
  Others: 'Autres'
};

export default fr;
